<script setup lang="ts">
defineProps<{
  productId: string
  productVariantId?: string | number
}>()

const open = defineModel('open', {
  default: false,
})

const { t } = useI18n()
</script>

<template>
  <UiDialog v-model:open="open">
    <UiDialogTrigger as-child>
      <UiButton
        data-testid="writeReviewButton"
        type="button"
        class="rounded-full text-sm font-medium fw600"
        variant="outline"
      >
        {{ t('product.write_review') }}
      </UiButton>
    </UiDialogTrigger>

    <UiDialogScrollContent>
      <UiDialogHeader>
        <UiDialogTitle>
          {{ t('product.write_review') }}
        </UiDialogTitle>
        <UiDialogDescription>
          {{ t('review.product_review_description') }}
        </UiDialogDescription>
      </UiDialogHeader>

      <LazyProductReviewCreateForm
        v-if="open"
        :product-id="productId"
        :product-variant-id="productVariantId"
        @close="open = false"
      />
    </UiDialogScrollContent>
  </UiDialog>
</template>
